import { TransitOperationFormValues } from 'features/declaration/models/schemas/transitOperationFormSchema'
import { ErrorResult } from '../../../../shared/models/types'

export type TransitOperationPartiallyPrefilledFields = 'id' | 'security' | 'specificCircumstanceIndicator'
| 'bindingItinerary' | 'transitCustomsOffices' | 'customsOfficesOfTransitExit' | 'status' | 'lrn' | 'mrn' | 'ensMrn'
| 'departureCustomsOffice' | 'destinationCustomsOffice' | 'customerId' | 'additionalDeclarationType' | 'limitDate'
| 'declarationType' | 'directoId' | 'entryIndicator'

interface TransitOperationAdditionalFields {
  auditReason: string
  feedback: string
  transitOperationInfoId?: number
  guaranteeClaimReservationStatus: string
  // directoId is read-only server info (passed to the isolated Directo tab), not an editable form field
  directoId: number | null
}

export type TransitOperation =
  Pick<TransitOperationFormValues, Exclude<TransitOperationPartiallyPrefilledFields, 'directoId'>> & TransitOperationAdditionalFields

type Data<T> = [T] extends [void]
  ? { data?: null }
  : { data: T }
export type ActionResult<T> = { success: true } & Data<T> | { success: false; errors: ErrorResult[] }

export type RestrictedConsignmentItem = {
  consignmentItemId: number | null
  declarationGoodsItemNumber: number | null
  hsCode: string | null
  descriptionOfGoods: string | null
}

export type RestrictionCheck = {
  restrictedConsignmentItems: RestrictedConsignmentItem[]
  restrictedTraderNames: string[]
  restrictedTransportMeans: string[]
}

export type GoodsIssueType = 'SANCTIONED_CODE' | 'GROSS_MASS_MISMATCH'

export interface GoodsIssue {
  type: GoodsIssueType
  message: string
  code?: string
  contextPath?: string
}

export type GuaranteeCalculation = {
  lrn: string
  mrn: string
  createdAt?: Date | null
  foreignCurrency: string
  currencyExchangeRate: number
  calculatedExciseSum: number
  calculatedDutySum: number
  calculatedVatSum: number
  calculatedTaxesSum: number
  foreignCurrencyCalculatedSum: number
  rows: GuaranteeCalculationRowData[]
}

export const EMPTY_GUARANTEE_CALCULATION: GuaranteeCalculation = {
  lrn: '',
  mrn: '',
  createdAt: null,
  foreignCurrency: 'EUR',
  currencyExchangeRate: 0,
  calculatedExciseSum: 0,
  calculatedDutySum: 0,
  calculatedVatSum: 0,
  calculatedTaxesSum: 0,
  foreignCurrencyCalculatedSum: 0,
  rows: [],
}

export type GuaranteeCalculationRowData = {
  sequenceNumber: number
  description: string
  commodityCode: string
  price: number
  excise: number
  dutyRate: number
  vatRate: number
  calculatedGuaranteedAmount: number
  calculatedDuty: number
  calculatedVat: number
}

export type EditorActionResult = {
  success: boolean
  message?: string
  errors?: ErrorResult[]
}

export type EditorAction =
  'pdf'
  | 'taxesPdf'
  | 'taxesXlsx'
  | 'generateXml'
